import { FilterTerms } from "../collections/filter-terms";
// model, with collection of terms.
var FilterOption = Backbone.Model.extend({
    defaults: {
        label: null,
        key: null,
        main: null,
        terms: null,
        type: 'dropdown',
        conditions:{},
        active: false,
        selection: null
    },
    initialize: function(){
        _.bindAll( this, 'termsChanged', 'clearOption' );
        let terms = new FilterTerms();
        this.set({'terms' : terms });
        this.listenTo( terms, 'change', this.termsChanged );
    },

    /*
    Update selection for this option
    */
    termsChanged: function(){
        // console.log( 'term changed' );
        var current = this.get( 'selection' );
        var terms =  this.get( 'terms' );
        // console.log( current );
        if ( current ) {
            this.stopListening( terms, 'change', this.termsChanged );
            let oldTerm = terms.findWhere({ 'value': current });
            if ( oldTerm ) {
                oldTerm.set({ selected: false });
            }
            this.listenTo( terms, 'change', this.termsChanged );
        }
        let selectedTerm = terms.findWhere({ selected: true });
        if ( selectedTerm ) {
            // console.log( selectedTerm.get( 'value' ) );
            this.set( { selection: selectedTerm.get('value') } );
        } else {
            this.set( { selection: null } );
        }
        this.trigger( 'change' );
    },
    /*
    Update the filter settings when the collection of options is changed.
    */
    clearOption: function(){
        var current = this.get( 'selection' );
        var terms =  this.get( 'terms' );
        this.stopListening( terms, 'change', this.termsChanged );

        if ( current ) {
            let oldTerm = terms.findWhere({ 'value': current });
            if ( oldTerm ) {
                oldTerm.set({ selected: false });
            }
        }
        let selectedTerm = terms.findWhere({ selected: true });
        if ( selectedTerm ) {
            selectedTerm.set({ selected: false });
        }
        this.set( { selection: null } );
        this.listenTo( terms, 'change', this.termsChanged );
    }
});
export {FilterOption};